import "./../profile.css";
import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";

interface IMember {
  open: boolean;
  editData: any;
  handleClose: () => void;
}
const CancelMessage = ({ open, handleClose, editData }: IMember) => {
  ReactModal.setAppElement("body");
  return (
    <ReactModal
      isOpen={open}
      /* style={customStyles} */
      onRequestClose={handleClose}
      className="my_acc_modal"
      overlayClassName="my_acc_overlay"
    >
      <div className="cross_button">
        <img src="/assets/img/my-profile/cross.png" alt="" className="cursor-pointer" onClick={handleClose} />
        <div className="acc_modal_content">
          {editData?.payment_txn_id && (editData?.payment_type == "online" || editData?.payment_type == "others") ? (
            <div>
              <p className="p-1 font-weight-bold text-center">
                Dear
                <span className="text-blue"> {editData?.CrmData?.patient_name || ""}</span>, Your Booking Id
                <span className="text-blue"> {editData?.crm_booking_id || ""} </span>, Payment
                <span className="text-blue"> ₹{editData?.advance_paid || 0}</span>, Payment Mode
                <span className="text-blue">
                  {" "}
                  {editData?.payment_type || ""}
                  {""}
                </span>
              </p>
              <p className="shadow-lg mt-3 p-2 text_dark font-weight-bold text-center">
                Your amount will be refunded within 3 working days as per RBI guideline
              </p>
            </div>
          ) : (
            <p className="shadow-lg mt-3 p-2 text_dark font-weight-bold text-center">
              Your order cancelled successfully.
            </p>
          )}
        </div>
      </div>
    </ReactModal>
  );
};

export default CancelMessage;
